import React from 'react';
import { compose, pure } from 'recompose';
import PropTypes from 'prop-types';
import HeaderNews from '../Header';
import ParseHtml from '../../../../core/ParseHTML';
import { StyledArticleColumn1 } from '../../style';

const TemplateMultimediaLeft = ({ body, ...props }) => (
  <StyledArticleColumn1>
    <HeaderNews {...props} />
    <ParseHtml html={body} />
  </StyledArticleColumn1>
);

TemplateMultimediaLeft.propTypes = {
  body: PropTypes.string
};
export default compose(pure)(TemplateMultimediaLeft);
